import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {
    idPacienteTotem: "", 
    preenchePacienteTotem: false, 
    appOnline: false, 
    appBrowserOnline: true, 
    appAPIOnline: true, 
    appAguardandoInternet: false, 
    appFabricante: "Micrologos", 
    appNome: "Clinic", 
    appVersao: process.env.VUE_APP_VERSION || "0", 
    appModoTotem: false, 
    appTotemUnidade: (window.localStorage.getItem("appTotemUnidade") ? JSON.parse(window.localStorage.getItem("appTotemUnidade")) : {}), 
    appTotemLocal: (window.localStorage.getItem("appTotemLocal") ? JSON.parse(window.localStorage.getItem("appTotemLocal")) : {}), 
    appInfoSuperior: "", 
    appPrimeiraEntrada: true, 
    appUsuariosOnline: [], 
    appIdioma: ""
};

const getters = {
    idPacienteTotem(state) {
        return state.idPacienteTotem;
    }, 
    preenchePacienteTotem(state) {
        return state.preenchePacienteTotem;
    }, 
    appOnline(state) {
        return state.appOnline;
    }, 
    appBrowserOnline(state) {
        return state.appBrowserOnline;
    }, 
    appAPIOnline(state) {
        return state.appAPIOnline;
    }, 
    appAllOnline(state) {
        return (state.appOnline && state.appBrowserOnline && state.appAPIOnline);
    }, 
    appAguardandoInternet(state) {
        return state.appAguardandoInternet;
    }, 
    appFabricante(state) {
        return state.appFabricante;
    }, 
    appNome(state) {
        return state.appNome;
    }, 
    appVersao(state) {
        return state.appVersao;
    }, 
    appModoTotem(state) {
        return state.appModoTotem;
    }, 
    appTotemUnidade(state) {
        return state.appTotemUnidade;
    }, 
    appTotemLocal(state) {
        return state.appTotemLocal;
    }, 
    appInfoSuperior(state) {
        return state.appInfoSuperior;
    }, 
    appPrimeiraEntrada(state) {
        return state.appPrimeiraEntrada;
    }, 
    appUsuariosOnline(state) {
        return state.appUsuariosOnline;
    }
};

const mutations = {
    upadateIdPacienteTotem(store, idPacienteTotem) {
        store.idPacienteTotem = idPacienteTotem;
    }, 
    upadatePreenchePacienteTotem(store, preenchePacienteTotem) {
        store.preenchePacienteTotem = preenchePacienteTotem;
    }, 
    updateAppOnline(store, appOnline) {
        store.appOnline = appOnline;
    }, 
    updateAppBrowserOnline(store, appBrowserOnline) {
        store.appBrowserOnline = appBrowserOnline;
    }, 
    updateAppAPIOnline(store, appAPIOnline) {
        store.appAPIOnline = appAPIOnline;
    }, 
    updateAppAguardandoInternet(store, appAguardandoInternet) {
        store.appAguardandoInternet = appAguardandoInternet;
    }, 
    updateAppModoTotem(store, appModoTotem) {
        store.appModoTotem = appModoTotem;
    }, 
    updateAppTotemUnidade(store, appTotemUnidade) {
        window.localStorage.setItem("appTotemUnidade", JSON.stringify(appTotemUnidade));
        store.appTotemUnidade = appTotemUnidade;
    }, 
    updateAppTotemLocal(store, appTotemLocal) {
        window.localStorage.setItem("appTotemLocal", JSON.stringify(appTotemLocal));
        store.appTotemLocal = appTotemLocal;
    }, 
    updateAppInfoSuperior(store, appInfoSuperior) {
        store.appInfoSuperior = appInfoSuperior;
    }, 
    updateAppPrimeiraEntrada(store, appPrimeiraEntrada) {
        store.appPrimeiraEntrada = appPrimeiraEntrada;
    }, 
    updateAppUsuariosOnline(store, appUsuariosOnline) {
        store.appUsuariosOnline = appUsuariosOnline;
    }, 
    updateAppUsuarioOnline(store, usuario) {
        if(usuario.online) {
            store.appUsuariosOnline.push(usuario);
        } else {
            const index = store.appUsuariosOnline.findIndex((u) => u.idEmitenteMLUsuario === usuario.idEmitenteMLUsuario);

            if (index >= 0) {
                store.appUsuariosOnline.splice(index, 1);
            }
        }
    }
};

const actions = {
    async checkApiStatus({ commit }) {
        if(JwtService.getToken()) {
            try {
                ApiService.setHeader();
                const { data } = await ApiService.get("auth/status");

                if(data.ok) {
                    commit("updateAppAPIOnline", true);
                } else {
                    commit("updateAppAPIOnline", false);
                }

                return data;
            } catch (error) {
                commit("updateAppAPIOnline", false);
                console.error(error);
                return {
                    ok: false, 
                    error
                }
            }
        }
    }, 
    upadateIdPacienteTotem({ commit }, idPacienteTotem) {
        commit('upadateIdPacienteTotem', idPacienteTotem);
    },
    upadatePreenchePacienteTotem({ commit }, preenchePacienteTotem) {
        commit('upadatePreenchePacienteTotem', preenchePacienteTotem);
    },
    updateAppOnline({ commit }, appOnline) {
        commit('updateAppOnline', appOnline);
    },
    updateAppBrowserOnline({ commit }, appBrowserOnline) {
        commit('updateAppBrowserOnline', appBrowserOnline);
    },
    updateAppAPIOnline({ commit }, appAPIOnline) {
        commit('updateAppAPIOnline', appAPIOnline);
    }, 
    updateAppAguardandoInternet({ commit }, appAguardandoInternet) {
        commit('updateAppAguardandoInternet', appAguardandoInternet);
    }, 
    updateAppModoTotem({ commit }, appModoTotem) {
        commit('updateAppModoTotem', appModoTotem);
    },
    updateAppTotemUnidade({ commit }, appTotemUnidade) {
        commit('updateAppTotemUnidade', appTotemUnidade);
    },
    updateAppTotemLocal({ commit }, appTotemLocal) {
        commit('updateAppTotemLocal', appTotemLocal);
    },
    updateAppInfoSuperior({ commit }, appInfoSuperior) {
        commit('updateAppInfoSuperior', appInfoSuperior);
    },
    updateAppPrimeiraEntrada({ commit }, appPrimeiraEntrada) {
        commit('updateAppPrimeiraEntrada', appPrimeiraEntrada);
    }, 
    async "SOCKET_usuariosOnline" ({ commit }, usuarios) {
        commit('updateAppUsuariosOnline', usuarios);
    }, 
    async "SOCKET_usuarioOnline" ({ commit }, usuario) {
        commit('updateAppUsuarioOnline', usuario);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};